module.exports = __webpack_public_path__ + "static/media/YoungGirl.d47cc0ec.png";